import { DefaultLayout } from "~/layouts/DefaultLayout";
import { CategoryList } from "~/components/CategoryList";
import { MetaHeader } from "~/components/MetaHeader";
import { AreaImages } from "~/constants";

const Area: React.VFC = () => {
    return (
        <>
            <MetaHeader title={"エリア検索 - 福岡カフェ日記 | 福岡最大級のカフェメディア"} description={"「エリア検索 | 福岡カフェ日記」で、福岡県内の様々なエリアから理想のカフェを見つけましょう。この機能を利用して、地図上で簡単にカフェを探索することができます。福岡市中央区から北九州市、さらには山間部の隠れ家カフェまで、あなたが訪れたいエリアを指定して、新しいお気に入りのカフェを発見することが可能です。各カフェには、ユーザーレビュー、写真、メニュー情報が含まれておりお店情報を詳細を確認できます。"} />
            <DefaultLayout>
                <h1 className="category_title">エリアから選ぶ</h1>
                <CategoryList categoryList={AreaImages} />
            </DefaultLayout>
        </>
    );
};

export default Area;